import api from './baseApi';
import type { TextShapeMaskFile, TextShapeSource } from './typings/textShape';

const controller = '/TextShapes';

/** Mask file of a shape, generated on the spot when it doesn't exist yet */
export const getTextShapeMask = (source: TextShapeSource): Promise<TextShapeMaskFile> =>
    ('path' in source
        ? api.get<TextShapeMaskFile>(`${controller}/Mask`, { params: { path: source.path } })
        : api.get<TextShapeMaskFile>(`${controller}/Mask/Library/${source.libraryId}/${source.position}`)
    ).then(({ data }) => data);

/** Generates, in the background, the mask files of every element of a library picked for a text shape */
export const generateLibraryTextShapeMasks = (libraryId: number): Promise<void> =>
    api.post(`${controller}/Masks/Library/${libraryId}`).then(() => undefined);
